import { sanitizeHtmlContent } from '../dompurify';

export const sanitizeSummaryAsText = (summary: string) => {
  return (summary || '')
    .replace(/<p>/g, '')
    .replace(/```/g, '')
    .replace(/<\/p>/g, '\n')
    .replace(/<strong style="color: rgb\(0, 208, 145\);">/g, '| ')
    .replace(/<strong style=['"]font-weight:\s*600;?['"]>/g, '')
    .replace(/<strong style="color: rgb\(0, 0, 0\);">/g, '')
    .replace(/<strong style="color: #00d091;">/g, '| ')
    .replace(/<strong style='color: #00d091;'>/g, '| ')
    .replace(/<strong style="color: #000;">/g, '')
    .replace(/<strong style='color: #000;'>/g, '')
    .replace(/<strong>/g, '')
    .replace(/<\/strong>/g, '')
    .replace(/<ul>/g, '')
    .replace(/<\/ul>/g, '\n')
    .replace(/<li>/g, '- ') // Replace <li> with dash+space (for bullet points)
    .replace(/<\/li>/g, '\n')
    .replace(/<br>/g, '\n')
    .replace(/\n\n+/g, '\n\n')
    .replace(/^\|+/gm, '')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .replace(/&cent;/g, '¢')
    .replace(/&pound;/g, '£')
    .replace(/&yen;/g, '¥')
    .replace(/&euro;/g, '€')
    .replace(/&copy;/g, '©')
    .replace(/&reg;/g, '®')
    .replace(/&trade;/g, '™')
    .trim();
};

export const sanitizeSummaryAsHtml = (
  summary: string,
  { prefix, suffix }: { prefix?: string; suffix?: string } = {}
) => {
  const html = [prefix, summary, suffix]
    .filter(Boolean)
    .join('<br /><br />')
    .replace(/\n/g, '<br>')
    .replace(/\\n/g, '<br>')
    .trim();
  return sanitizeHtmlContent(html);
};
